import DefaultIndividualsFeatureList from './features/defaultIndividualsFeatureList';
import StandardMonthlyFeatureList from './features/standardMonthlyFeatureList';
import FeatureRules from './rules/featureRules';
import summaryFeaturesTransformer from './summaryFeaturesTransformer';
import { formatSummaryFeature } from '~app/pages/Pricing/lib/packageFeatures';

export default summaryFeaturesTransformer([...DefaultIndividualsFeatureList, ...StandardMonthlyFeatureList], {
  ...FeatureRules,
  // Add feature rule overrides below
  support: () => formatSummaryFeature('email_support'),
  statistical_significance: () => formatSummaryFeature('text_analysis'),
});
